import { spacing } from '../functions';

export default {
  root: {
    display: 'flex',
    padding: `${spacing(6)} 0`,
  },
};
